import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";
import {
  buildPageHead,
  breadcrumbSchema,
  contactPageSchema,
  personSchema,
} from "@/lib/seo";

export const Route = createFileRoute("/contact")({
  head: () =>
    buildPageHead({
      title: "Contact Marjohn Robillo | Book a Free Discovery Call",
      description:
        "Book a free 30-minute discovery call with Marjohn Robillo, Revenue Operations Architect. Map your CRM, automation, and revenue systems — no payment, discovery only.",
      path: "/contact",
      keywords:
        "contact Marjohn Robillo, book discovery call, revenue operations architect, CRM automation consultation, free strategy call",
      schema: [
        contactPageSchema(),
        personSchema(),
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Contact", path: "/contact" },
        ]),
      ],
    }),
  component: Contact,
});
